export default __webpack_public_path__ + "static/media/thumb-GNSS-Receiver-5.904f688a.png";